const toMonthStart = (date: Date) =>
  new Date(date.getFullYear(), date.getMonth(), 1);

const toMonthEnd = (date: Date) => {
  const endOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);
  endOfMonth.setHours(0, 0, 0, 0);
  return endOfMonth;
};

export { toMonthStart, toMonthEnd };
